export default {
  slug: "writerside",
  code: "WRS",
  label: "Writerside",
  logoFamily: "jb",
};
